module.exports = __webpack_public_path__ + "img/experience01.d0f11421.jpg";